import React from 'react';
import { Page } from 'components';
import { ChannelsProvider } from './ChannelsContext';
import Channels from './Channels';


let Index = () => {
    return (
        <ChannelsProvider>
            <Page title="Channels">
                <Channels />
            </Page>
        </ChannelsProvider>
    );
}

export default Index;